export default __webpack_public_path__ + "static/media/ShieldCheck.4f4755b7.svg";